import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Typography from '@/design-system/atoms/Typography';

import styles from './Badge.module.scss';

/**
 * Optional Card Badge Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {string} props.className - Additional class name
 * @param {string} props.type - Badge type
 * @param {string} props.label - Badge label
 * @param {object} props.otherProps - Additional props
 */
export const Badge = React.forwardRef((props, ref) => {
    const { className, type, label, ...otherProps } = props;

    return (
        <div
            ref={ref}
            className={classnames(styles['badge'], styles[`badge--${type}`], className)}
            {...otherProps}
        >
            <Typography variant="e1" content={label} lineClamp={{ sm: 1, lg: 1 }} />
        </div>
    );
});

Badge.displayName = 'Badge';

Badge.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
};

export default Badge;
